import { render, staticRenderFns } from "./RadiosAction.vue?vue&type=template&id=2d2c8c73&scoped=true&"
import script from "./RadiosAction.vue?vue&type=script&lang=js&"
export * from "./RadiosAction.vue?vue&type=script&lang=js&"
import style0 from "./RadiosAction.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RadiosAction.vue?vue&type=style&index=1&id=2d2c8c73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c8c73",
  null
  
)

export default component.exports